import 'css-chunk:src/index/components/schedule/columns_list.module.scss';export default {
  "sectionIcons": "sectionIcons__-akqC"
};